import React, { useContext } from "react";
import { ChevronLeft, Grid } from "react-feather";
import { Link } from "react-router-dom";
import CustomizerContext from "../../_helper/Customizer";
import { getStoredUser } from "../../api/auth";
import { roleHomePath } from "../../constants/menuAccess";
import { Image } from "../../AbstractElements";
import { logoDark as CubaDarkIcon, logoLight as CubaIcon } from "../../assets/brand/credoraLogos";

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, toggleIcon, layout, layoutURL } = useContext(CustomizerContext);
  const homePath = roleHomePath(getStoredUser(), layoutURL);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  return (
    <div className='logo-wrapper'>
      {layout1 !== "compact-wrapper dark-sidebar" && layout1 !== "compact-wrapper color-sidebar" && mixLayout ? (
        <Link to={homePath}>
          <Image attrImage={{ className: "img-fluid d-inline", src: `${CubaIcon}`, alt: "" }} />
        </Link>
      ) : (
        <Link to={homePath}>
          <Image attrImage={{ className: "img-fluid d-inline", src: `${CubaDarkIcon}`, alt: "" }} />
        </Link>
      )}
      <div className='back-btn' onClick={() => openCloseSidebar()}>
        <ChevronLeft size={18} strokeWidth={2} aria-hidden />
      </div>
      <div className='toggle-sidebar' onClick={openCloseSidebar}>
        <Grid className='status_toggle middle sidebar-toggle' />
      </div>
    </div>
  );
};

export default SidebarLogo;
